import { Column } from 'react-table';
import styled from '@emotion/styled';
import { Label } from '@britishcouncil/react-admin';
import { WritingCertificationListItem } from 'api';
import { formatDate } from 'utils';
import { CheckIcon, ViewDetailsButton } from 'components';

export const COLUMNS: Column<WritingCertificationListItem>[] = [
  {
    Header: 'Date of Certification',
    accessor: 'dateOfCertification',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Set',
    accessor: 'writingCertificationSetName',
  },
  {
    Header: 'Pass Indicator',
    accessor: 'isPassed',
    Cell: ({ value }) => (
      <S.LabelWrapper>
        <Label color={value ? 'green' : 'red'}>{value ? 'Pass' : 'Fail'}</Label>
      </S.LabelWrapper>
    ),
  },
  {
    Header: 'First Attempt',
    accessor: 'isFirstAttempt',
    width: '100px',
    Cell: CheckIcon,
  },
  {
    Header: 'Pass at ET Level',
    accessor: 'isPassedAtEtLevel',
    width: '100px',
    Cell: CheckIcon,
  },
  {
    Header: 'IDP',
    accessor: 'isFromIdp',
    width: '100px',
    Cell: CheckIcon,
  },
  {
    Header: '',
    accessor: 'id',
    width: '60px',
    Cell: ({ value }) => <ViewDetailsButton to={value} />,
  },
];

const S = {
  LabelWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
};
